(() => {
  const mobile = window.matchMedia('(max-width: 768px)');
  const updateMobileHeader = () => {
    document.documentElement.classList.toggle('apply-mobile-header-scrolled', mobile.matches && window.scrollY > 8);
  };

  window.addEventListener('scroll', updateMobileHeader, { passive: true });
  window.addEventListener('resize', updateMobileHeader);
  window.addEventListener('pageshow', updateMobileHeader);
  updateMobileHeader();
})();

(() => {
  const forms = document.querySelectorAll('form.apply-contact-form');

  forms.forEach(form => {
    const fields = [
      form.querySelector('[name="contact[name]"]'),
      form.querySelector('[name="contact[company]"]'),
      form.querySelector('[name="contact[email]"]'),
      form.querySelector('[name="contact[know_about_you]"]'),
    ].filter(Boolean);
    const key = `apply-contact:${form.id}`;
    const feedback = form.querySelector('[data-apply-contact-feedback]');

    try {
      if (form.querySelector('.note--success')) {
        sessionStorage.removeItem(key);
      } else if (feedback) {
        const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
        fields.forEach(field => {
          if (saved[field.name] && !field.value) field.value = saved[field.name];
        });
      }
    } catch (_) {
      // Storage can be unavailable in private browsing; form validation still works.
    }

    if (feedback) feedback.focus();

    const required = fields.filter(field => field.required);
    const summary = document.createElement('div');
    summary.className = 'apply-contact-form__errors';
    summary.setAttribute('role', 'alert');
    summary.setAttribute('tabindex', '-1');
    summary.hidden = true;
    form.querySelector('.apply-contact-form__required')?.before(summary);

    const errors = new Map();
    const messages = field => field.type === 'email'
      ? 'Enter an email like name@example.com.'
      : 'Enter your name.';

    function renderErrors() {
      summary.replaceChildren();
      summary.hidden = errors.size === 0;
      if (!errors.size) return;

      const title = document.createElement('p');
      const strong = document.createElement('strong');
      strong.textContent = 'Please correct the following:';
      title.append(strong);
      const list = document.createElement('ul');

      for (const [field, message] of errors) {
        const id = `${field.id}-client-error`;
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('aria-describedby', id);
        let detail = form.querySelector(`[id="${id}"]`);
        if (!detail) {
          detail = document.createElement('p');
          detail.id = id;
          detail.className = 'apply-contact-form__field-error';
          field.after(detail);
        }
        detail.textContent = message;

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${field.id}`;
        link.textContent = message;
        item.append(link);
        list.append(item);
      }

      summary.append(title, list);
    }

    form.noValidate = true;
    form.addEventListener('submit', event => {
      errors.clear();
      required.forEach(field => {
        if (!field.checkValidity()) errors.set(field, messages(field));
      });
      renderErrors();

      if (errors.size) {
        event.preventDefault();
        summary.focus();
        return;
      }

      try {
        sessionStorage.setItem(key, JSON.stringify(Object.fromEntries(fields.map(field => [field.name, field.value]))));
      } catch (_) {
        // A rejected storage write must not stop a valid form submission.
      }
    });

    required.forEach(field => field.addEventListener('input', () => {
      if (!field.checkValidity() || field.getAttribute('aria-invalid') !== 'true') return;
      errors.delete(field);
      const describedBy = field.getAttribute('aria-describedby');
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
      describedBy?.split(/\s+/).forEach(id => {
        const detail = document.getElementById(id);
        if (detail && form.contains(detail) && detail.classList.contains('apply-contact-form__field-error')) detail.remove();
      });
      feedback?.querySelector(`a[href="#${field.id}"]`)?.closest('li')?.remove();
      if (feedback?.classList.contains('apply-contact-form__errors') && !feedback.querySelector('li')) feedback.hidden = true;
      renderErrors();
    }));
  });
})();
